const UnsavedhangesModal = (props) => {
  return (
    <>
      <div
        className="overlay overlay-no-blur"
        onClick={() => props.Close()}
      ></div>
      <div className="modal">
        <h1>Unsaved Changes</h1>
        <p>
          You have unsaved changes: If you leave the page, your changes will be
          discarded
        </p>
        <section>
          <span onClick={() => props.DisacardAndLeave()}>
            Discard and leave
          </span>
          <span onClick={() => props.Save()}>Save</span>
        </section>
      </div>
    </>
  );
};

export default UnsavedhangesModal;
